var render, staticRenderFns
import script from "./ConfirmPop.vue?vue&type=script&lang=js"
export * from "./ConfirmPop.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPop.vue?vue&type=style&index=0&id=2bfe8a87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports